export const handleInputKeyPressForQtyAndValueInput = (event, decimalPlacesParam) => {
    const inputValue = event.target.value
    const pressedKey = event.key
    const tmpDecimalPlaces = decimalPlacesParam ? decimalPlacesParam : 0
    const allowComma = tmpDecimalPlaces > 0

    if (event.ctrlKey || event.metaKey) {
        return true
    }
    const navigationKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Tab', 'Delete']
    if (navigationKeys.includes(pressedKey)) {
        return true
    }

    if (pressedKey === '.' || pressedKey === ',') {
        if (tmpDecimalPlaces === 0 || inputValue.includes('.') || inputValue.includes(',')) {
            return false
        }
    }
    if (allowComma) {
        if (!/[0-9]/.test(pressedKey) && pressedKey !== "Backspace" && pressedKey !== '.' && pressedKey !== ',') {
            return false
        }
    }
    else {
        if (!/[0-9]/.test(pressedKey) && pressedKey !== "Backspace") {
            return false
        }
    }
    // if (tmpDecimalPlaces === 0) {
    //     if ((inputValue.length === 0 && pressedKey === '0') ||
    //         (inputValue === "0" && inputValue.length === 1 && pressedKey === '0')) {
    //         return false
    //     }
    // }
    if (inputValue === '0' && pressedKey === '0') {
        return false // blokuje wpisania 0 gdy 0 jest pierwsze
    }
    return true
}

export const handleOnChangeForQtyAndValueInput = (event, decimalPlacesParam, salesRatio) => {
    let value = event.target.value == '' || event.target.value.trim() == '' ? '' : event.target.value
    event.target.value = value
    const tmpDecimalPlaces = decimalPlacesParam ? decimalPlacesParam : 0
    const allowComma = tmpDecimalPlaces > 0
    let addCommaToLenght = tmpDecimalPlaces === 0 ? 0 : 1
    if (value.length >= (6 + decimalPlacesParam + addCommaToLenght)) {
        return false
    }
    let regex
    if (allowComma) {
        regex = new RegExp(`^\\d*((\\.|,)\\d{0,${tmpDecimalPlaces}})?$`)
    }
    else {
        // regex = new RegExp(`[0-9]`)
        regex = new RegExp(`^[0-9]*$`);
    }
    if (!regex.test(value)) {
        return false
    }
    return true
}

export const handleInputForQtyAndValueFocus = (event, isDevexpressComponent) => {
    if (isDevexpressComponent) {
        event.component.selectAll()
    }
    else {
        event.target.select()
    }
}

export const handleInputForQtyAndValueLostFocus = (event, decimalPlacesParam) => {
    const tmpDecimalPlaces = decimalPlacesParam ? decimalPlacesParam : 0
    event.target.value = parseFloat(event.target.value).toFixed(tmpDecimalPlaces)
}

/**
 * DK : Parser do inputów text zwracajacy w odpowiedzi float, z uwzględnieniem przecinka jako separatora miejsc dziesiętnych
 * @param {*} value wartość
 * @returns 
 */
export const parseTextToFloat = (value) => {
    return parseFloat(String(value).replace(',', '.'))
}

/**
 * DK : Zaokrąglenie kwoty do pełnych groszy - usuwa błędy arytmetyki zmiennoprzecinkowej (np. 441.40 - 300.00 = 141.39999999999998)
 * @param {*} value wartość
 * @returns kwota zaokrąglona do 2 miejsc po przecinku, NaN gdy wartość nie jest liczbą
 */
export const roundValueToCents = (value) => {
    const parsedValue = parseTextToFloat(value)
    if (isNaN(parsedValue)) {
        return parsedValue
    }
    return Math.round(parsedValue * 100) / 100
}